<template>
  <div>
    <el-breadcrumb>
      <el-breadcrumb-item><router-link to="./">首页</router-link></el-breadcrumb-item>
      <el-breadcrumb-item>申请进度模板</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content">
      <el-form inline label-width="60px" size="small" class="query-form" @submit.native.prevent="selClick">
        <el-form-item label="搜索">
          <el-input v-model="key" placeholder="期数名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selClick">查询</el-button>
          <el-button type="success" @click="addClick">新增模板</el-button>
        </el-form-item>
      </el-form>
      <el-card class="box-card table">
        <div slot="header"><span>进度模板（4/7/10/1月）</span></div>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="termName" label="期数名称" min-width="120"></el-table-column>
          <el-table-column prop="termCode" label="期数代码" width="90"></el-table-column>
          <el-table-column prop="sort" label="排序" width="70"></el-table-column>
          <el-table-column label="启用" width="70">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isEnable" type="success">是</el-tag>
              <el-tag v-else type="info">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="editClick(scope.row)">编辑</el-button>
              <el-button type="text" @click="openStep(scope.row)">节点管理</el-button>
              <el-button type="text" style="color:#f56c6c" @click="delClick(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="margin-top:20px">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10,20,30,50]" :page-size="pageSize"
            layout="total,prev,sizes,pager,next,jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>

    <el-dialog :title="form.id > 0 ? '编辑模板' : '新增模板'" :visible.sync="dialogVisible" width="520px">
      <el-form :model="form" ref="form" label-width="100px" @submit.native.prevent="submitForm">
        <el-form-item label="入学期" prop="termCode" :rules="[{ required: true, message: '请选择' }]">
          <el-select v-model="form.termCode" style="width:100%" @change="onTermChange">
            <el-option v-for="item in termList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="form.termName" placeholder="默认同入学期"></el-input>
        </el-form-item>
        <el-form-item label="排序"><el-input v-model.number="form.sort"></el-input></el-form-item>
        <el-form-item label="启用"><el-switch v-model="form.isEnable"></el-switch></el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">保存</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :title="'节点管理 - ' + (curTemplate.termName || '')" :visible.sync="stepDialogVisible" width="960px">
      <el-button type="success" size="small" @click="addStepClick" style="margin-bottom:12px">添加节点</el-button>
      <el-table :data="stepList" border stripe size="small">
        <el-table-column prop="stepOrder" label="顺序" width="60"></el-table-column>
        <el-table-column prop="description" label="工作阶段" width="130"></el-table-column>
        <el-table-column prop="stepName" label="关键节点" min-width="140"></el-table-column>
        <el-table-column prop="stepCode" label="编码" width="100"></el-table-column>
        <el-table-column label="通知" width="60">
          <template slot-scope="scope">{{ scope.row.notifyEnable ? '是' : '否' }}</template>
        </el-table-column>
        <el-table-column prop="daysBeforeAbroad" label="距出国(天)" width="100"></el-table-column>
        <el-table-column label="话术" width="70">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.scriptContent" type="success" size="mini">已填</el-tag>
            <el-tag v-else type="info" size="mini">未填</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="附件" width="70">
          <template slot-scope="scope">
            <el-tag v-if="hasAttach(scope.row.attachJson)" type="warning" size="mini">有</el-tag>
            <el-tag v-else type="info" size="mini">无</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="editStepClick(scope.row)">编辑</el-button>
            <el-button type="text" style="color:#f56c6c" @click="delStepClick(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :title="stepForm.id > 0 ? '编辑节点' : '添加节点'" :visible.sync="stepEditVisible" width="720px">
      <el-form :model="stepForm" ref="stepForm" label-width="110px" @submit.native.prevent="submitStep">
        <el-form-item label="工作阶段">
          <el-input v-model="stepForm.description" placeholder="如：在留材料制作申请"></el-input>
        </el-form-item>
        <el-form-item label="关键节点" prop="stepName" :rules="[{ required: true, message: '必填' }]">
          <el-input v-model="stepForm.stepName"></el-input>
        </el-form-item>
        <el-form-item label="节点编码"><el-input v-model="stepForm.stepCode"></el-input></el-form-item>
        <el-form-item label="顺序"><el-input v-model.number="stepForm.stepOrder"></el-input></el-form-item>
        <el-form-item label="话术（默认）">
          <el-input
            v-model="stepForm.scriptContent"
            type="textarea"
            :rows="6"
            placeholder="默认展示。签证办理节点=小花办理话术。可用 *同学 / 【同学姓名】 占位。"
          ></el-input>
        </el-form-item>
        <el-form-item label="话术（自己办签）">
          <el-input
            v-model="stepForm.scriptContent2"
            type="textarea"
            :rows="5"
            placeholder="仅签证办理等节点需要：学生选择「自己办理」时展示"
          ></el-input>
          <div class="form-tip">学生进度里可切换「小花办理 / 自己办理」；空则始终用默认话术。</div>
        </el-form-item>
        <el-form-item label="回访/调查链接">
          <el-input v-model="stepForm.followLink" placeholder="https://... 或小程序路径 /pages/..."></el-input>
          <div class="form-tip">赴后回访等节点可填表单链接；小程序进度页可点击打开或复制。</div>
        </el-form-item>
        <el-form-item label="图片/文档/视频">
          <CaseFileUpload
            v-model="stepAttachFiles"
            :upload-id="'progress-step-attach'"
            :active="stepEditVisible"
            file-exts="jpg;jpeg;png;gif;bmp;webp;pdf;doc;docx;xls;xlsx;ppt;pptx;txt;zip;rar;7z;mp4;mov;m4v;webm"
            btn-text="上传图片/文档/视频"
          />
          <div class="form-tip">支持视频（如电话调查指导）；学生在小程序可直接播放。</div>
        </el-form-item>
        <el-form-item label="距出国天数"><el-input v-model.number="stepForm.daysBeforeAbroad"></el-input></el-form-item>
        <el-row :gutter="16">
          <el-col :span="8"><el-form-item label="主节点"><el-switch v-model="stepForm.isMainNode"></el-switch></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="必填"><el-switch v-model="stepForm.isRequired"></el-switch></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="微信通知"><el-switch v-model="stepForm.notifyEnable"></el-switch></el-form-item></el-col>
        </el-row>
        <el-form-item label="启用"><el-switch v-model="stepForm.isEnable"></el-switch></el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">保存</el-button>
          <el-button @click="stepEditVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import CaseFileUpload from "@/components/CaseFileUpload.vue";

export default {
  name: "progressTemplate",
  components: { CaseFileUpload },
  data() {
    return {
      key: "",
      loading: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      termList: [],
      form: {},
      dialogVisible: false,
      submiting: false,
      curTemplate: {},
      stepDialogVisible: false,
      stepList: [],
      stepForm: {},
      stepAttachFiles: [],
      stepEditVisible: false
    };
  },
  created() {
    $.get(url.getProgress("GetSelList_EnrollTerm"), {}, res => { this.termList = res; });
    this.getList();
  },
  methods: {
    api(a) { return url.getProgress(a); },
    hasAttach(json) {
      try {
        var arr = typeof json === "string" ? JSON.parse(json || "[]") : (json || []);
        return Array.isArray(arr) && arr.length > 0;
      } catch (e) { return false; }
    },
    parseAttach(json) {
      try {
        var arr = typeof json === "string" ? JSON.parse(json || "[]") : (json || []);
        return Array.isArray(arr) ? arr : [];
      } catch (e) { return []; }
    },
    handleSizeChange(val) { this.pageSize = val; this.currentPage = 1; this.getList(); },
    handleCurrentChange(val) { this.currentPage = val; this.getList(); },
    selClick() { this.currentPage = 1; this.getList(); },
    getList() {
      this.loading = true;
      $.get(this.api("GetList_Template"), {
        key: this.key, pageindex: this.currentPage, pagesize: this.pageSize
      }, data => {
        this.loading = false;
        this.tableData = data.list;
        this.total = data.total;
      });
    },
    onTermChange(val) {
      const item = this.termList.find(x => x.id === val);
      if (item && !this.form.termName) this.form.termName = item.name;
    },
    addClick() {
      this.form = { isEnable: true, sort: 0, termCode: 4 };
      this.dialogVisible = true;
    },
    editClick(row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    },
    delClick(row) {
      this.$confirm("确定删除？", "提示", { type: "warning" }).then(() => {
        $.post(this.api("Delete_Template"), { id: row.id }, res => {
          if (res.status) { this.getList(); this.$message.success(res.msg); }
          else this.$message.error(res.msg);
        });
      }).catch(() => {});
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.submiting = true;
        $.post(this.api("Save_Template"), this.form, res => {
          this.submiting = false;
          if (res.status) { this.dialogVisible = false; this.getList(); this.$message.success(res.msg); }
          else this.$message.error(res.msg);
        });
      });
    },
    openStep(row) {
      this.curTemplate = row;
      this.loadSteps();
      this.stepDialogVisible = true;
    },
    loadSteps() {
      $.get(this.api("GetList_Step"), { templateId: this.curTemplate.id }, res => {
        this.stepList = res || [];
      });
    },
    addStepClick() {
      this.stepForm = {
        templateID: this.curTemplate.id,
        isEnable: true,
        isMainNode: true,
        isRequired: true,
        notifyEnable: false,
        scriptContent: "",
        scriptContent2: "",
        followLink: "",
        attachJson: "[]",
        stepOrder: (this.stepList.length + 1) * 10
      };
      this.stepAttachFiles = [];
      this.stepEditVisible = true;
    },
    editStepClick(row) {
      this.stepForm = Object.assign({}, row);
      this.stepAttachFiles = this.parseAttach(row.attachJson);
      this.stepEditVisible = true;
    },
    delStepClick(row) {
      this.$confirm("确定删除节点？", "提示", { type: "warning" }).then(() => {
        $.post(this.api("Delete_Step"), { id: row.id }, res => {
          if (res.status) { this.loadSteps(); this.$message.success(res.msg); }
          else this.$message.error(res.msg);
        });
      }).catch(() => {});
    },
    submitStep() {
      this.$refs.stepForm.validate(valid => {
        if (!valid) return;
        this.submiting = true;
        var payload = Object.assign({}, this.stepForm, {
          attachJson: JSON.stringify(this.stepAttachFiles || [])
        });
        $.post(this.api("Save_Step"), payload, res => {
          this.submiting = false;
          if (res.status) { this.stepEditVisible = false; this.loadSteps(); this.$message.success(res.msg); }
          else this.$message.error(res.msg);
        });
      });
    }
  }
};
</script>

<style scoped>
.query-form { margin-top: 20px; padding-top: 25px; background: #f2f2f2; }
.form-tip { color: #909399; font-size: 12px; line-height: 1.5; margin-top: 6px; }
</style>

